import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { toastError } from 'Common/ToastHelper';
import { FILE_DELIMITER_OPTIONS } from 'Common/Constants';
import FileConfigurationComponent from './../components/FileConfiguration';

class FileConfiguration extends Component {
  static propTypes = {
    displayDropZone: PropTypes.bool,
  };
  static defaultProps = {
    displayDropZone: false,
  };
  fileFormatOptions = [
    {
      value: 'delimiter',
      key: 'delimiter',
      text: 'Delimited',
    },
  ];
  onDrop = files => {
    if (!files[0]) {
      toastError('Please choose a file.');
      return;
    }
    this.props.handleFilePreview(files[0]);
  };

  render() {
    const { displayDropZone } = this.props;
    return (
      <FileConfigurationComponent
        displayDropZone={displayDropZone}
        fileFormatOptions={this.fileFormatOptions}
        delimiterButtonOptions={FILE_DELIMITER_OPTIONS}
        onDrop={this.onDrop}
      />
    );
  }
}
export default FileConfiguration;



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/importInventory/containers/FileConfiguration.js